import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Menu } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

import OnTraccrButton from '../../../../common/buttons/OnTraccrButton';
import OnTraccrCheckbox from '../../../../common/inputs/OnTraccrCheckbox';

const getItemKey = (groupKey, value) => `${groupKey}.${value}`;

export default function CostTrackingColumnChanger({ groups, style }) {
  const [open, setOpen] = useState(false);

  const itemMap = useMemo(() => {
    const map = new Map();
    groups.forEach(({
      key: groupKey,
      options,
      hiddenKeySet,
      onToggle,
    }) => {
      options.forEach(({ value }) => {
        map.set(getItemKey(groupKey, value), { value, hiddenKeySet, onToggle });
      });
    });
    return map;
  }, [groups]);

  const onMenuClick = useCallback(({ key }) => {
    const item = itemMap.get(key);
    if (!item) return;
    const { value, hiddenKeySet, onToggle } = item;
    onToggle(value)(hiddenKeySet.has(value));
  }, [itemMap]);

  const overlay = (
    <Menu
      selectable={false}
      onClick={onMenuClick}
      style={{
        width: 250,
        maxHeight: 500,
        overflowY: 'auto',
      }}
    >
      {groups.map(({
        key: groupKey,
        title,
        options,
        hiddenKeySet,
      }) => (
        <Menu.ItemGroup
          key={groupKey}
          title={<span style={{ color: 'black', fontWeight: 600, fontSize: 15 }}>{title}</span>}
        >
          {options.map(({ label, value }) => (
            <Menu.Item key={getItemKey(groupKey, value)}>
              {/* Menu.Item owns the click so the whole row toggles exactly once */}
              <OnTraccrCheckbox
                label={label}
                value={!hiddenKeySet.has(value)}
                onChange={() => {}}
                style={{ pointerEvents: 'none' }}
              />
            </Menu.Item>
          ))}
        </Menu.ItemGroup>
      ))}
    </Menu>
  );

  return (
    <span
      role="presentation"
      style={{ display: 'inline-flex' }}
      onClick={(e) => e.stopPropagation()}
    >
      <Dropdown
        trigger={['click']}
        placement="bottomRight"
        overlay={overlay}
        visible={open}
        onVisibleChange={setOpen}
      >
        <OnTraccrButton
          title="Columns"
          icon={<SettingOutlined />}
          type="cancel"
          style={style}
        />
      </Dropdown>
    </span>
  );
}

CostTrackingColumnChanger.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    hiddenKeySet: PropTypes.instanceOf(Set).isRequired,
    onToggle: PropTypes.func.isRequired,
  })).isRequired,
  style: PropTypes.shape({}),
};

CostTrackingColumnChanger.defaultProps = {
  style: undefined,
};
